module.exports = __webpack_public_path__ + "static/hero-right1-0dce7fe88c3a82eb91b8d2573127c667.svg";